var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"trigger-bestseller-view",attrs:{"data-tracking":"machine_sheet__button__best_seller_tab"},on:{"click":function($event){return _vm.$emit('trigger')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }